import {
  SET_SPINNER_LOADING,
  ACTION_SET_SIDE_BAR_QUICK_ACTION,
  GETTER_SIDE_BAR_QUICK_ACTION,
  MUTATION_SET_SIDE_BAR_QUICK_ACTION,
  ACTION_SET_CLIENT_SELECTED,
  MUATAION_SET_CLIENT_SELECTED,
  GETTER_CLIENT_SELECTED,
  ACTION_API_CURRENT_VERSION,
  MUTATION_API_CURRENT_VERSION,
  GETTER_API_CURRENT_VERSION
} from "./constants";
import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";

export const state = {
  isLoading: false,
  isSideBarQuickActionActive: false,
  clientSelected: {},
  apiVersion: {}
};

export const actions = {
  [ACTION_SET_SIDE_BAR_QUICK_ACTION]({ commit }, toggle) {
    commit(MUTATION_SET_SIDE_BAR_QUICK_ACTION, toggle);
  },
  [ACTION_SET_CLIENT_SELECTED]({ commit }, client) {
    commit(MUATAION_SET_CLIENT_SELECTED, client);
  },
  [ACTION_API_CURRENT_VERSION]: ({ commit }, options) => {
    makeCall(
      getEndPoints().apiVersion.getCurrent,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response) {
        commit(MUTATION_API_CURRENT_VERSION, response);
      }
    });
  }
};

export const getters = {
  isLoading: state => state.isLoading,
  [GETTER_SIDE_BAR_QUICK_ACTION]: state => state.isSideBarQuickActionActive,
  [GETTER_CLIENT_SELECTED]: state => state.clientSelected,
  [GETTER_API_CURRENT_VERSION]: state => state.apiVersion
};

export const mutations = {
  [SET_SPINNER_LOADING](currentState, toggle) {
    currentState.isLoading = toggle;
  },
  [MUTATION_SET_SIDE_BAR_QUICK_ACTION](currentState, toggle) {
    currentState.isSideBarQuickActionActive = toggle;
  },
  [MUATAION_SET_CLIENT_SELECTED](currentState, client) {
    currentState.clientSelected = client;
  },
  [MUTATION_API_CURRENT_VERSION](currentState, version) {
    currentState.apiVersion = version;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js